<xui-value #costs [binding]="value">
  <xui-number-formatter [maxDecimals]="2" [unit]="unit"></xui-number-formatter>
</xui-value>

<span class="name">{{ translationKey | translate }}:</span>
<span>{{ costs.value }}</span>
